import React, { Fragment, useState, useEffect, useRef} from "react";
import { Row, Col, Container, Card, Collapse } from "reactstrap";
import "../../style/styleeconfirm.css";


export default function PopUpLeave(props) {
  // const {toggle}=props.toggle;
  const [open, setOpen] = useState('false');

  useEffect(() => {
    props.toggle ==true ? setOpen('true') : setOpen('false')
  }, [props.toggle]);

  return (
    <div className="popup-overlayn">
      <div className="popup-contentn">
<br/>

<br/>
<h6>Half day already exist. Are you want to convert to Full day leave?</h6>

<br/>

<div>
<button className="btn-admin-settings btn btn-" onClick={props.hadleDelWithPopYes}>Yes</button>&nbsp;&nbsp;
<button className="btn-cancel btn btn-" onClick={props.hadleDelWithPopNo}>No</button>
</div>
<br/>
{/* </div> */}
</div>
      </div>
  );
}
